/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_CheckoutInputs */

const en_admin_funnel_history_checkout = /** @type {(inputs: Admin_Funnel_History_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started checkout`)
};

/**
* | output |
* | --- |
* | "Started checkout" |
*
* @param {Admin_Funnel_History_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_checkout = /** @type {((inputs?: Admin_Funnel_History_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_checkout(inputs)
});
export { admin_funnel_history_checkout as "admin.funnel.history.checkout" }